"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icons = require("../../atoms/Icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimpleHeader = function SimpleHeader(_ref) {
  var icon = _ref.icon,
      infoText = _ref.infoText,
      className = _ref.className;
  var cls = (0, _classnames.default)(className, 'w-full h-13 bg-secondary px-6 py-4 flex justify-between items-center');
  var logo = !icon ? /*#__PURE__*/_react.default.createElement(_Icons.LogoSara, null) : icon;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cls
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "logo w-20"
  }, logo), /*#__PURE__*/_react.default.createElement("div", {
    className: "pl-3 info-text text-white text-right uppercase text-xs sm:text-base"
  }, infoText));
};

SimpleHeader.propTypes = {
  icon: _propTypes.default.object,
  infoText: _propTypes.default.string,
  className: _propTypes.default.string
};
var _default = SimpleHeader;
exports.default = _default;